import { Link } from 'react-router-dom';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Button } from 'reactstrap';

SwiperCore.use([Navigation]);

const SlidingHighlights = (props: any) => {
  const sliders = [
    {
      category: 'food-beverage',
      name: 'Food & Beverage',
      path: `${process.env.PUBLIC_URL}/images/lob/cat--fnb.png`,
    },
    {
      category: 'fashion',
      name: 'Fashion',
      path: `${process.env.PUBLIC_URL}/images/lob/cat--fashion.png`,
    },
    {
      category: 'beauty',
      name: 'Beauty',
      path: `${process.env.PUBLIC_URL}/images/lob/cat--beauty.png`,
    },
    {
      category: 'hotel-dining',
      name: 'Hotel & Dining',
      path: `${process.env.PUBLIC_URL}/images/lob/cat--hotel.png`,
    },
    {
      category: 'groceries',
      name: 'Groceries',
      path: `${process.env.PUBLIC_URL}/images/lob/cat--groceries.png`,
    },
    {
      category: 'home-appliance',
      name: 'Home Appliance',
      path: `${process.env.PUBLIC_URL}/images/lob/cat--home-appliances.png`,
    },
    {
      category: 'e-commerce',
      name: 'e-Commerce',
      path: `${process.env.PUBLIC_URL}/images/lob/cat--ecommerce.png`,
    },
    {
      category: 'reward-bca',
      name: 'Reward BCA',
      path: `${process.env.PUBLIC_URL}/images/lob/cat--reward.png`,
    },
  ];

  function SetCategory(category: any) {
    props.resetFilter();
    props.setCategoryFilter(category);
  }

  return (
    <div className="SlidingHighlights">
      <Swiper
        spaceBetween={10}
        slidesPerView={'auto'}
        navigation={{
          nextEl: '.next-el',
          prevEl: '.prev-el',
        }}
        breakpoints={{
          480: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 'auto',
            spaceBetween: 20,
          },
        }}
      >
        {sliders.map((slider: any, i: number) => (
          <SwiperSlide key={i}>
            <div className="shadow">
              <Link
                to={{
                  pathname: '/',
                  search: `?category=${slider.category}`,
                }}
                onClick={() => SetCategory([String(slider.category)])}
                className="stretched-link"
              >
                <img src={slider.path} className="w-100" alt={`Highlight ${i}`} />
              </Link>
            </div>
          </SwiperSlide>
        ))}
        <div className="d-flex justify-content-end navigation-wrapper">
          <Button color="link" className="prev-el nav-slider swiper-button-disabled">
            ‹
          </Button>
          <Button color="link" className="next-el nav-slider">
            ›
          </Button>
        </div>
      </Swiper>
    </div>
  );
};

export default SlidingHighlights;
